<template>
  <extensions-list
    v-if="selectedMsp.id"
    :tier="tierType"
    :id="selectedMsp.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ExtensionsList from "@/views/Common/AttachmentFilters/Extension.vue";

import { TIER } from "@/constants";

export default {
  name: "Extensions",
  components: {
    ExtensionsList,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
